import React from "react";

function CustProfile() {
  return <div>Customer Profile Page</div>;
}

export default CustProfile;
